module.exports = require("./az-Latn.js");